export default "__VITE_ASSET__DfTd5QeU__"